const MAX_VIDEO_SIZE_BYTES = 100 * 1024 * 1024;

export function validateVideoFileSize(file) {
    if (file.size > MAX_VIDEO_SIZE_BYTES) {
        return '影片檔案請上傳 100MB 以下';
    }
    return null;
}

// 檢查是否為 YouTube URL
export function isYouTubeUrl(url) {
    return url.includes('youtube.com') || url.includes('youtu.be');
}
// 確保 YouTube URL 是 embed 格式
export function getYouTubeEmbedUrl(url) {
    var _a, _b;
    // 如果已經是 embed 格式，直接返回
    if (url.includes('/embed/')) {
        return url;
    }
    // 處理 youtu.be 短網址
    if (url.includes('youtu.be/')) {
        const videoId = (_a = url.split('youtu.be/')[1]) === null || _a === void 0 ? void 0 : _a.split('?')[0];
        return `https://www.youtube.com/embed/${videoId}`;
    }
    // 處理 youtube.com/watch?v= 格式
    if (url.includes('watch?v=')) {
        const videoId = (_b = url.split('watch?v=')[1]) === null || _b === void 0 ? void 0 : _b.split('&')[0];
        return `https://www.youtube.com/embed/${videoId}`;
    }
    return url;
}
// 從 YouTube URL 獲取縮圖
export function getYouTubeThumbnail(url) {
    var _a, _b, _c;
    let videoId = '';
    if (url.includes('/embed/')) {
        videoId = ((_a = url.split('/embed/')[1]) === null || _a === void 0 ? void 0 : _a.split('?')[0]) || '';
    }
    else if (url.includes('youtu.be/')) {
        videoId = ((_b = url.split('youtu.be/')[1]) === null || _b === void 0 ? void 0 : _b.split('?')[0]) || '';
    }
    else if (url.includes('watch?v=')) {
        videoId = ((_c = url.split('watch?v=')[1]) === null || _c === void 0 ? void 0 : _c.split('&')[0]) || '';
    }
    if (videoId) {
        return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    }
    return '';
}
